import { AfterViewInit, Component, OnInit } from "@angular/core";
import * as AOS from "aos";
import { DateTime } from "luxon";
import { AppService } from "@services/app.service";
import { PricingPackage } from "@pages/modal/pricing-plans/pricingPlans";

@Component({
  selector: "app-website-shop",
  templateUrl: "./shop.component.html",
  styleUrls: ["./shop.component.scss"],
})
export class ShopComponent implements OnInit, AfterViewInit {
  pricingPlans: PricingPackage[] = [];
  loading = true;
  public currentYear: string = DateTime.now().toFormat("y");

headerColors = [
  '#A0522D', // Sienna Brown
  '#4682B4', // Steel Blue
  '#556B2F', // Dark Olive Green
  '#CC9900', // Muted Gold
  '#6A5ACD'  // Slate Blue-Violet
];
cardColors = [
  '#FBF6F4', // Off-White with Red Tint
  '#F5F9FC', // Off-White with Blue Tint
  '#F7FAF6', // Off-White with Green Tint
  '#FFFBF6', // Off-White with Yellow Tint
  '#F7F5FC'  // Off-White with Violet Tint
];


  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.getAllPackages();
  }

getAllPackages(): void {
  this.appService.getAllPackages().subscribe({
    next: (res: any) => {
      this.pricingPlans = res; // ✅ show all plans
      this.loading = false;
    },
    error: (err) => {
      console.error("Failed to load pricing plans:", err);
      this.loading = false;
    },
  });
}

  ngAfterViewInit(): void {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }
}
